module.exports = {
    // base: "/mock/v1",
    // path:"http://10.168.1.229:7070/api/v1",
    base: "/api",
    // base: "http://139.198.180.211:7070/api/v1",
    path: "http://139.198.180.211:7070/api/v1",
    topath:'http://10.168.1.120:3000/selectTeam?v=1'
};